export type NuxtPayloadValueContainingAndUrl = {
    urlBase64: string;
};

export const NuxtPayloadUrlEncoder = {
    encode: (payloadToEncode: string): NuxtPayloadValueContainingAndUrl | undefined => {
        if (payloadToEncode && /^(\/|http[s]?:\/\/).+/.test(payloadToEncode)) {
            try {
                const encoded = encodeURI(payloadToEncode);
                return {urlBase64: btoa(encoded)};
            } catch {}
        }
    },
    decode: (payloadToDecode: NuxtPayloadValueContainingAndUrl): string => {
        try {
            return decodeURI(atob(payloadToDecode.urlBase64));
        } catch {
            return payloadToDecode.urlBase64;
        }
    },
};
